import { Injectable } from '@angular/core';
import { environment } from 'environments/environment.prod';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Constants } from '../environments/constants';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { Http } from '@angular/http';

@Injectable()


export class httpservice {
n:any;
iFramUrl:any;
constructor(private sanitizer: DomSanitizer,private http:Http) {
 
}

fetchgetr(url,cb) {
  this.n = Date.now();
  const req = new XMLHttpRequest();
  req.open('GET',  environment.dburlr+'/api/'+url+'&n='+this.n);
  req.onload = () => {
    console.log('DONE', req.readyState); // readyState will be 4
    return [cb(JSON.parse(req.response)),req.readyState];

  };
  req.send();
  console.log("url:",environment.dburlr+'/api/'+url+'&n='+this.n);
}


fetchgetpc(url,cb) {
  this.n = Date.now();
  const req = new XMLHttpRequest();
  req.open('GET',  environment.dburlpc+'/api/'+url+'&n='+this.n);
  req.onload = () => {
    console.log('DONE', req.readyState); // readyState will be 4
    return [cb(JSON.parse(req.response)),req.readyState];

  };
  req.send();
  console.log("url:",environment.dburlpc+'/api/'+url+'&n='+this.n);
}


fetchgetn(url,cb) {
  this.n = Date.now();
  const req = new XMLHttpRequest();
  req.open('GET',  environment.dburlnodejs+'/api/'+url+'&n='+this.n);
  req.onload = () => {
    console.log('DONE', req.readyState); // readyState will be 4
    return [cb(JSON.parse(req.response)),req.readyState];

  };
  req.send();
  console.log("url:",environment.dburlnodejs+'/api/'+url+'&n='+this.n);
}

fetchget(url,cb) {
    this.n = Date.now();
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/'+url+'&n='+this.n);
    req.onload = () => {
      console.log('DONE', req.readyState); // readyState will be 4
      return [cb(JSON.parse(req.response)),req.readyState];
  
    };
    req.send();
    console.log("url:",environment.url+'/api/'+url+'&n='+this.n);
  }


  fetchgetm(url,cb) {
    this.n = Date.now();
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/'+url+'&n='+this.n);
    req.onload = () => {
      if (req.readyState == 4) {
        console.log('DONE', req.readyState); // readyState will be 4
        return cb([JSON.parse(req.response),true]);
      }else{
        return cb([[],false]);
      }
    };
    req.send();
    console.log("url:",environment.url+'/api/'+url+'&n='+this.n);
  }

  fetchpost(url,data,cb) {
    this.n = Date.now();
    console.log('postdata url',url);
    const req = new XMLHttpRequest();
    req.open('POST',  environment.url+'/api/'+url);
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    req.onreadystatechange = function () {//Call a function when the state changes.
        if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
          // Request finished. Do processing here.
          req.onload = () => {
            console.log('postdata',JSON.parse(req.response));
            return cb(JSON.parse(req.response));
          };
        }
      }
    req.send(JSON.stringify(data));
    console.log("url:",environment.url+'/api/'+url);
    console.log("data:",data);
  }


  fetchpostr(url,data,cb) {
    this.n = Date.now();
    console.log('request url',url);
    const req = new XMLHttpRequest();
    req.open('POST', url);
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    req.onreadystatechange = function () {//Call a function when the state changes.
        if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
          // Request finished. Do processing here.
          req.onload = () => {
            console.log('response data',JSON.parse(req.response));
            return cb(JSON.parse(req.response));
          };
        }
      }
    req.send(JSON.stringify(data));
    console.log("requst data:",data);
  }
  fethttppost(url,data,cb){
  this.http.post(url, data).map((data)=>{return data.json();}).subscribe(success => {
    //console.log(success);
    return cb(success);
  }, error => {
    console.log(error.json());
  });
  }


  openExport(exportSection:string){
    this.iFramUrl=this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/api/"+exportSection+"?");
  }
  openPrint(printSection:string){
  let popupWinindow
  popupWinindow = window.open( environment.url+'/api/'+printSection+'?', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
 
  }

}

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value,Constants.DATE_FMT);
  }
}

@Pipe({
  name: 'dateTimeFormat'
})


export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, Constants.DATE_TIME_FMT);
  }
}


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/http/http.ts